import React from 'react';
import {
  RailsBlock,
  RailsPageView,
} from '@sls-react/typings/services/rails/tile';
import useCarousel from '@sls-react/hooks/useCarousel';
import useTileVersions from '@sls-react/hooks/useTileVersions';
import { useInterval } from 'react-use';
import CloseIcon from '@sls-react/static/svg/CloseIcon';
import useKnownCookie from '@sls-react/hooks/useKnownCookie';
import { useMicroBannerDismissalState } from '@sls-react/components/Chrome/Banners/MicroBanner';

interface Props {
  block: RailsBlock;
  pageView: RailsPageView;
}

const MicroBannerBlock: React.FC<Props> = ({ block, pageView }) => {
  const carousel = useCarousel(block.tiles?.length!);
  const versions = useTileVersions(block);
  const [time, setTime] = useKnownCookie('sls_dmicro_b');
  const [state, setState] = useMicroBannerDismissalState();

  useInterval(carousel.goToNextIndex, 5000);
  const slide = versions?.[carousel.index];
  if (!slide) {
    return null;
  }

  return (
    <a
      href={slide.destination}
      className="flex items-center px-4 text-sm text-center text-white h-14 bg-turf-green-500 transition-colors duration-200"
      style={{
        color: slide.text_color || undefined,
        backgroundColor: slide.background_color || undefined,
      }}
    >
      <span className="flex-1" />
      <span>{slide.title}</span>
      <span className="flex-1" />
      <button
        className="p-4 -m-4"
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          setTime(Number(new Date(pageView.updated_at)).toString(), {
            expires: 300,
          });
          setState(1);
        }}
      >
        <CloseIcon fill="currentColor" />
      </button>
    </a>
  );
};

export default MicroBannerBlock;
